import { FunctionComponent, MouseEvent, memo, useCallback } from 'react';
import { Story } from '../../../services';
import { useStoryFollow } from '../../hooks';
import { isStoryFollowable } from '../../utils';
import { FollowChip } from '../FollowChip';

interface StoryFollowChipProps {
  story: Story;
  truncate?: boolean;
  className?: string;
}

export const StoryFollowChip: FunctionComponent<StoryFollowChipProps> = memo(
  ({ story, truncate, className }) => {
    const { isStoryFollowed, toggleStoryFollow, isFollowPending } = useStoryFollow();

    const { title } = story;

    const handleClick = useCallback(
      (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        toggleStoryFollow(story);
      },
      [story, toggleStoryFollow]
    );

    if (!isStoryFollowable(story)) {
      return null;
    }

    return (
      <FollowChip
        label={title}
        followed={isStoryFollowed(story)}
        isPending={isFollowPending}
        onClick={handleClick}
        truncate={truncate}
        className={className}
      />
    );
  }
);
